import React, { useEffect } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import { supabase } from "../../client";

const Address = ({ details, setDetails }) => {
  const history = useHistory();
  const updateAddress = async (e) => {
    e.preventDefault();
    let id = supabase.auth.user().id;
    let data = new FormData(e.target);
    let name = data.get("name");
    let address = data.get("address");
    let city = data.get("city");

    let state = data.get("state");
    let pincode = data.get("pincode");

    try {
      const { error } = await supabase.from("profiles").upsert({
        id: id,
        name: name,
        address: address,
        city: city,
        state: state,
        pincode: pincode,
      });
      setDetails([
        {
          id: id,
          name: name,
          address: address,
          city: city,
          state: state,
          pincode: pincode,
        },
      ]);
      if (error) throw error;
      history.goBack();
    } catch (error) {
      alert(error.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await supabase
        .from("profiles")
        .select()
        .eq("id", supabase.auth.user().id);
      setDetails(data);
    };
    fetchData();
  }, [setDetails]);

  return (
    <Right style={{ marginBottom: "5em" }}>
      <Heading>MY ADDRESS</Heading>
      <form onSubmit={(e) => updateAddress(e)}>
        <input type="text" name="name" id="name" placeholder="Name" required />
        <input
          type="text"
          name="address"
          id="address"
          placeholder="Address"
          required
        />
        <input type="text" name="city" id="city" placeholder="City" required />
        <input
          type="text"
          name="state"
          id="state"
          placeholder="State"
          required
        />
        <input
          type="text"
          inputMode="numeric"
          name="pincode"
          id="pincode"
          placeholder="Pincode"
          required
        />
        <Button type="submit">Submit</Button>
      </form>
      <Card>
        <Heading>Current Address</Heading>
        {details[0] && (
          <>
            <p>{details[0].name}</p>
            <p>{details[0].address}</p>
            <p>{details[0].city}</p>
            <p>{details[0].state}</p>
            <p>{details[0].pincode}</p>
          </>
        )}
      </Card>
    </Right>
  );
};
const Card = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 5px #aaaa;
  padding: 1em;
`;
const Right = styled.div`
  width: 75%;
  border: 1px solid #ddd;
  padding: 2em;
  form {
    display: flex;
    flex-direction: column;
  }
  input,
  button {
    padding: 1em;
    margin: 1em 0;
  }
  input {
    border: 1px solid #ddd;
  }
`;

const Heading = styled.div`
  color: #525252;
  font-size: 1.3rem;
  font-weight: 500;
  margin: 0.5em 0;
`;

const Button = styled.button`
  width: 8em;
  border: none;
  align-self: flex-start;
  margin-top: 1em;
  padding: 1em 2em;
  background-color: #83aa4c;
  border-radius: 32px;
  color: white;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
  :hover {
    scale: 1.1;
  }
`;
export default Address;
